import type { ManagedReceivingPartnerApi as Api } from "@capstone/mock-api";

export class DashboardTicketOrderVendor {
  private constructor(
    args: Omit<ClassProperties<DashboardTicketOrderVendor>, "displayName">,
  ) {
    this.id = args.id;
    this.name = args.name;
    this.number = args.number;

    // Computed Properties
    this.displayName = `${this.name} (${this.number})`;
  }

  public readonly id: number;
  public readonly name: string;
  public readonly number: string;

  // Computed Properties
  public readonly displayName: string;

  public static deserialize(
    apiModel: Pick<Api.Vendor, "id" | "name" | "vendorNumber">,
  ): DashboardTicketOrderVendor {
    return new DashboardTicketOrderVendor({
      id: apiModel.id,
      name: apiModel.name,
      number: apiModel.vendorNumber,
    });
  }
}
